// extracted by mini-css-extract-plugin
export var content = "CreateAccount-module__content___t0aaX";